<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modal.title"
    @on-confirm="save"
    @on-cancel="hide()"
    :okText="$t('Save')"
    :closeText="$t('Close')"
    maxWidth="60%"
  >
    <div>
      <p class="font-weight-bold">
        {{ $t("InternalTableImportFormat") }}
      </p>
      <p class="font-weight-regular">
        {{ $t("InternalTableImportNameFile") }}
      </p>
      <p class="font-weight-regular">
        {{ $t("InternalTableImportColumnsName") }}
      </p>
      <p class="font-weight-regular">
        {{ $t("InternalTableImportData") }}
      </p>
    </div>
    
    <v-file-input
      v-model="excelFile"
      :label="$t('Import')"
      accept=".xlsx"
      prepend-icon="mdi-microsoft-excel"
    ></v-file-input>
  </base-modal>
</template>
<script>
import InternalTableService from "@/services/InternalTableService";
import Utils from "@/ecm/common/Utils";

export default {
  data() {
    return {
      modal: {
        title: `${this.$t("InternalTables")} - ${this.$t("Import")}`,
        key: "internalTablesImportModal",
      },
      open: false,
      excelFile: null,
    };
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modal.key];
    },
  },
  methods: {
    save() {
      if (this.excelFile) {
        this.modalInstance.progress(true);

        let formData = new FormData();
        formData.append("excelFile", this.excelFile);

        InternalTableService.import(formData)
          .then(() => {
            this.$t("InternalTable") + " " + this.$t("CreatedSuccessfully")
            this.$emit("on-imported");
            this.hide();
          })
          .catch((error) => {
            // error
          })
          .then(() => {
            //always
            this.modalInstance.progress(false);
          });
      }
    },
    show() {
      this.$nextTick(() => {
        this.excelFile = null;
      });
      this.open = true;
    },
    hide() {
      this.open = false;
    },
  },
};
</script>
